"use client";
import { useEffect, useState, useCallback } from "react";
import { z } from "zod";
import { UserSchema } from "@/schemas/user.schema";
import { setTokenData, getTokenData, removeTokenData } from "@/helpers/token.helper";

export type CurrentUser = z.infer<typeof UserSchema>;

export function useCurrentUser(): {
    user: CurrentUser | null,
    setCurrentUser: (token: string, u: CurrentUser) => void,
    deleteCurrentUser: () => void
} {
    const [user, setUser] = useState<CurrentUser | null>(null);

    const setCurrentUser = useCallback((token: string, u: CurrentUser) => {
        setTokenData(token, u);
        setUser(u);
    }, []);

    const deleteCurrentUser = useCallback(() => {
        removeTokenData();
        setUser(null);
    }, []);

    useEffect(() => {
        const stored = getTokenData();
        if (stored?.user) {
            setUser(stored.user);
        } else {
            setUser(null);
        }
    }, []);

    return {
        user,
        setCurrentUser,
        deleteCurrentUser
    };
}
